import React, { useState } from "react";
import { Row, Col, Container, Card } from "react-bootstrap";
import PaymentPanel from "./PaymentPanel";
import PremiumInfo from "./PremiumInfo";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import "./Subscription.scss";
import { useTranslation } from "react-i18next";

const Subscription = () => {
  const location = useLocation();
  const { search } = location;
  const query = queryString.parse(search);
  const monthly = query.plan;
  const plan = query.plan;
  const tier = query.tier;
  const {t}= useTranslation()

  const [selectMonthly, setSelectMonthly] = useState(monthly == "monthly");

  return (
    <Container fluid className="sub">
      <Row className="bg-white py-2 justify-content-between sub-header">
        <a href="/" style={{ textDecoration: "none" }} className="ml-5">
          <span className="font-weight-bold" style={{ fontSize: "20px" }}>
            <img src="/images/logo.png" width="55" className="mr-2" />
            CFDHero
          </span>
        </a>
      </Row>

      <Row className="justify-content-around mt-5" noGutters>
        <Col xs={12} md={6} xl={5} className="px-0 px-sm-3 px-xl-5">
          <PremiumInfo readOnly isYearly={!selectMonthly} tier={tier} t={t} plan={plan}/>
        </Col>
        <Col
          xs={12}
          md={6}
          xl={5}
          className="px-0 px-sm-3 px-xl-5 mt-5 mt-md-0"
          style={{ maxWidth: 800 }}
        >
          <PaymentPanel
            monthly={selectMonthly}
            hideSelection={monthly != null}
            onChange={setSelectMonthly}
            subscriptionType={plan}
            tier={tier}
            plan={plan}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default connect(null)(Subscription);
